import React from "react";
import MainTable from '../../Components/Tables/Main/MainTable'
import {useParams} from "react-router-dom";
import { userTypes } from "../../CommonConstants";
import {useLeases} from "../../Hooks/useLeases";
import {useVehicles} from "../../Hooks/useVehicles";
import {useCompanies} from "../../Hooks/useCompanies";
import {useUsers} from "../../Hooks/useUsers";
import {useAgreements} from "../../Hooks/useAgreements";

const Leases = (props) => {
    let { agreementId } = useParams();
    agreementId = +agreementId;
    const [leasesData, addLease, updateLease, deleteLease] = useLeases(agreementId);

    const [agreements] = useAgreements();
    const agreement = agreements.find((agreement) => {
        return agreement.id === agreementId;
    });

    const [companies] = useCompanies();
    let company

    if(agreement){
      company = companies.find((company) => {
        return company.id === agreement.companyName;
      });
    }

    let [vehicles] = useVehicles(true);
    vehicles = vehicles.reduce(
        function (acc, cur) {
          const { id, brand, model, patent, year } = cur;
          acc[id] = `${brand} ${model} ${patent} ${year}`;
          return acc;
        },
        {}
      )
    
    const [users] = useUsers();
    const drivers = users.reduce(function (acc,cur) {
        const { id, email, type, companyName } = cur;
        if (type === userTypes.driver.type && (!agreement || companyName === agreement.companyName)){
            acc[id] = email;
        }
        return acc;
      },
      {});

    const columns = [
        { title: "Número de arrendamiento", field: "id", editable: "never", defaultSort: 'desc' },
        { title: "Vehiculo", field: "vehicle", lookup: vehicles },
        { title: "Conductor", field: "driver", lookup: drivers }
    ];

    return <MainTable 
            title={`Arrendamientos para ${company ? company.name : ''}`}
            columns={columns}
            data={leasesData}
            requiredFields={["vehicle", "driver"]}
            deleteText="Se borraran todos los requerimientos asociados"
            onRowAdd={addLease}
            onRowUpdate={updateLease}
            onRowDelete={deleteLease}
            />
}

export default Leases


// WEBPACK FOOTER //
// ./src/Containers/Leases/Leases.js